import Vue from 'vue'

import { STATUS_PLANED } from '@/config/config'
import {
  cityIconDistrib,
  cityIconNotDistrib,
  tkoTypeStatusLoadingIconMap,
} from './icons'
import { IconGarbage, IconObject, IconCar } from './icon/MapIcons'
import { OBJECT } from './types'
import { REGION_CONFIG } from '@/config/regions'

class MarkerCreator {
  vm = null

  constructor(vm = {}) {
    this.vm = vm
  }

  getTkoMarker(obj, id, options = {}) {
    let iconType = 'object_util'
    if (obj.is_mps == true) {
      iconType = 'mps'
    } else if (obj.is_intermunicipal == true) {
      iconType = 'mmco'
    }
    let iconStatus = obj.status_id == STATUS_PLANED ? 'y' : 'g'
    let iconLoading = 'r'
    let percentOfLoading = 0
    if (Number(obj.power) > 0 && Number(obj.garbage_sum) > 0) {
      obj.power = parseFloat(obj.power).toFixed(2)
      obj.power = obj.power * 1000
      percentOfLoading =
        parseFloat(obj.garbage_sum).toFixed(2) / (obj.power / 100)
      if (percentOfLoading > 70) {
        iconLoading = 'r'
      } else if (percentOfLoading > 50) {
        iconLoading = 'y'
      } else {
        iconLoading = 'g'
      }
    } else {
      iconLoading = 'n'
      percentOfLoading = null
    }

    // set delete for logical delete
    if (obj.thread_del) {
      options.opacity = 0.5
    }
    if (
      REGION_CONFIG.hasObjectPowerColor &&
      Number(obj.size_tonn) > Number(obj.power)
    ) {
      iconLoading = 'o'
    }
    let hash = `${iconType}${iconStatus}${iconLoading}`
    obj.percentOfLoading = percentOfLoading
    options.icon = tkoTypeStatusLoadingIconMap[hash]
    return this.createMarker(obj, options)
  }

  getCityMarker(obj, id, options = {}) {
    let cityIcon
    if (obj.isDistrib || !obj.hasOwnProperty('isDistrib')) {
      cityIcon = cityIconDistrib
    } else {
      cityIcon = cityIconNotDistrib
    }
    options.icon = cityIcon
    return this.createMarker(obj, options)
  }

  getOrCreateCarMarker(obj, id, options = {}) {
    options.icon = this.createCarIcon(
      obj.layerConfig.iconType,
      obj.subLayerConfig.iconType,
      obj
    )
    options.openedPopupInfo = id
    return this.createMarker(obj, options)
  }

  getOrCreateGarbageMarker(obj, id, options = {}) {
    options.icon = this.createGarbageIcon(
      obj.layerConfig.iconType || null,
      obj.subLayerConfig.iconType,
      obj
    )
    options.openedPopupInfo = id
    return this.createMarker(obj, options)
  }

  getOrCreateObjectMarker(obj, id, options = {}) {
    options.icon = this.createIconObject(
      obj.layerConfig.iconType || null,
      obj.subLayerConfig ? obj.subLayerConfig.iconType : null,
      obj
    )
    options.openedPopupInfo = id
    return this.createMarker(obj, options)
  }

  getOrCreateMSNMarker(obj, id, options = {}) {
    options.icon = this.createIconObject(
      obj.layerConfig.iconType || null,
      obj.subLayerConfig ? obj.subLayerConfig.iconType : null,
      obj
    )
    options.openedPopupInfo = id
    return this.createMarker(obj, options)
  }

  getOrCreateUnauthorizedHeapMarker(obj, id, options = {}) {
    options.icon = this.createIconObject(
      obj.layerConfig.iconType,
      obj.subLayerConfig ? obj.subLayerConfig.iconType : null,
      obj
    )
    options.openedPopupInfo = id
    return this.createMarker(obj, options)
  }

  getMarker(obj, markerId = null, options = {}) {
    if (!obj.lat || !obj.lng) {
      console.warn(
        'Unknow lat, lng for ' + obj.type + ' = ' + JSON.stringify(obj)
      )
      // return
    }
    options.model = obj
    options.openedPopupInfo = markerId
    options.layerConfig = obj.layerConfig || null
    options.subLayerConfig = obj.subLayerConfig || null
    switch (obj.type) {
      case OBJECT.UNAUTHORIZED_TKO:
      case OBJECT.TKO: {
        //TODO заменить этот костыль на разделение контекстов: отрисовка для карты и отрисовка для схемы прогнозирования
        return obj.layerConfig
          ? this.getOrCreateObjectMarker(obj, markerId, options)
          : this.getTkoMarker(obj, markerId, options)
      }
      case OBJECT.CITY: {
        return this.getCityMarker(obj, markerId, options)
      }
      case OBJECT.GARBAGE: {
        return this.getOrCreateGarbageMarker(obj, markerId, options)
      }
      case OBJECT.UNAUTHORIZED_HEAP: {
        return this.getOrCreateUnauthorizedHeapMarker(obj, markerId, options)
      }
      case OBJECT.MSN: {
        return this.getOrCreateMSNMarker(obj, markerId, options)
      }
      case OBJECT.CAR: {
        return this.getOrCreateCarMarker(obj, markerId, options)
      }
      case OBJECT.CIRCLE:
      case OBJECT.EQUIDISTANT: {
        return this.getCircleMarker(obj, markerId, options)
      }
      default: {
        return this.getOrCreateObjectMarker(obj, markerId, options)
      }
    }
  }

  getCircleMarker(obj, markerId, options = {}) {
    let markerOptions = Object.assign(
      {
        radius: 3,
      },
      options
    )
    return L.circleMarker([obj.lat || 0, obj.lng || 0], markerOptions)
  }

  createCarIcon(iconType, iconSubType, model = null, options = {}) {
    options.iconType = iconType
    options.iconSubType = iconSubType
    options.model = model
    return new IconCar(options)
  }

  createIconObject(iconType, iconSubType, model = null, options = {}) {
    options.iconType = iconType
    options.iconSubType = iconSubType
    options.model = model
    return new IconObject(options)
  }

  createGarbageIcon(iconType, iconSubType, model = null, options = {}) {
    options.iconType = iconType
    options.iconSubType = iconSubType
    options.model = model
    return new IconGarbage(options)
  }

  circle(obj, radius = 10) {
    if (!obj.lat || !obj.lng) {
      console.warn(
        'Unknow lat, lng for ' + obj.type + ' = ' + JSON.stringify(obj)
      )
      // return
    }
    return L.circle([obj.lat || 0, obj.lng || 0], radius)
  }

  createMarker(obj, options) {
    return new L.Marker([obj.lat || 0, obj.lng || 0], {
      ...options,
      draggable: REGION_CONFIG.hasDraggableMarker,
      ...(obj.id && {
        contextmenu: true,
        contextmenuItems: [
          {
            text: 'Скопировать ссылку',
            callback: () =>
              Vue.prototype.$emitter.emit('copyObjectCardLinkToClipboard', {
                id: obj.id,
                subLayerConfig: obj.subLayerConfig,
              }),
          },
        ],
      }),
    })
  }
}

export default MarkerCreator
